// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DynamicFormFieldDefinitionListResultModel from '../../model/dynamic-form-field-definition-list-result-model';
import DynamicFormFieldDefinitionListResultDTO from '../dto/dynamic-form-field-definition-list-result-dto';
import dtoSchema from '../schemas/dynamic-form-field-definition-list-result-schema';
import DynamicFormFieldDefinitionModel from '../../model/dynamic-form-field-definition-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class DynamicFormFieldDefinitionListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DynamicFormFieldDefinitionListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => DynamicFormFieldDefinitionModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: DynamicFormFieldDefinitionModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<DynamicFormFieldDefinitionListResultDTO>): DynamicFormFieldDefinitionListResultModel;
  static toModel(dto: DeepPartial<DynamicFormFieldDefinitionListResultDTO> | undefined | null): DynamicFormFieldDefinitionListResultModel | undefined;
  static toModel(dto: DeepPartial<DynamicFormFieldDefinitionListResultDTO> | undefined | null): DynamicFormFieldDefinitionListResultModel | undefined {
    return dto ? new DynamicFormFieldDefinitionListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DynamicFormFieldDefinitionListResultModel> | DynamicFormFieldDefinitionListResultModel): DynamicFormFieldDefinitionListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as DynamicFormFieldDefinitionListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DynamicFormFieldDefinitionListResultModel, can not map to DynamicFormFieldDefinitionListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
